import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import GCArchive from './GCArchive';
import AddIcon from '@material-ui/icons/Add';
import { dateFormatUtil } from '../Utilities';

import ReactExport from 'react-export-excel';


import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const pageSizes = [5, 10, 25, 50, 100];
const statusArray =[
    { key: 'Approved', value: 'Approved' },
    { key: 'Pending', value: 'Pending' },
    { key: 'Rejected', value: 'Rejected' },
]
const searchBy = [
    { key: 'Title', value: 'title' },
];



export function MaterialUIPickers(props) {
    
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var firstDay = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
    
    const [selectedDate, setSelectedDate] = React.useState(firstDay);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        props.setDate(date);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justifyContent="space-around">
                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="none"
                    id={props.id}
                    label={props.label}
                    value={selectedDate}
                    onChange={handleDateChange}
                    maxDate={new Date()}
                    autoOk={true}
                    KeyboardButtonProps={{
                        'aria-label': 'change date'
                    }}
                />
            </Grid>
        </MuiPickersUtilsProvider>
    );
}

class AllList extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        
        showArchiveList:false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'title',
        selectedItem:[],

        modalShow: false,
        alert: 0,
        alertMessage: '',
        data: [],
        selectedRow: [],
        giftcardsAMACoupon: [],
        DownloadReady:false,
        isLoading: true,
        report_from_date:this.getFormattedDate(new Date()),
        report_to_date:this.getFormattedDate(new Date()),
        report_title:''
    };
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            userRole: 'Admins',
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };

        
        await RestServices.getAllMasterGiftCards(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
            
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            isLoading: false,
                            alert: 0
                        });
                    }
                    
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ isLoading: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ isLoading: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    
    

    listArchive = (rowData) => {
        if (this._isMounted) {
            this.setState({ showArchiveList: true,selectedRow: rowData });
        }
    };
    
    hideArchive  = () => {
        if (this._isMounted) {
            this.setState({ showArchiveList: false, selectedRow: [] });
        }
    };

    

    
    addReport = (item)=>{
        if (this._isMounted) {
        this.setState({DownloadReady:false,selectedItem:item, modalShow: true,alert:0,alertMessage:'' });
        }
    } 
    
    getFormattedDate(date) {
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    createReport = async () => {
       
let bodyData = {
    title: this.state.report_title,
    fromDate: this.state.report_from_date,
    search_key: this.state.report_from_date,
    search_by:'Date',
    toDate: this.state.report_to_date,
    MasterGiftCard: this.state.selectedItem.title,
    LastUpdatedTimeStamp: dateFormatUtil(),
    UpdatedBy: this.props.user.FullName
        ? this.props.user.FullName
        : 'Admin'
};
     

this.setState({DownloadReady:false, isLoading: true,alert:0,alertMessage:''});
await RestServices.getMyGiftCards(
    localStorage.getItem('FirebaseToken'),
    bodyData
)
    .then((response) => response.json())
    .then((responseData) => {
        
        var giftcardsList =[]
        var dataList = responseData.list;
        if(dataList.length>0){
        for (let i = 0; i < dataList.length; i++) {
            if(dataList[i].status ==='COMPLETE'){
                giftcardsList.push({
                    refno:dataList[i].refno?dataList[i].refno:'null',
                    sku:dataList[i].GCSku?dataList[i].GCSku:'null',
                    productName:dataList[i].productName,
                    giftOrderId:dataList[i].orderId?dataList[i].orderId:'null',
                    ProfileUniqeID:dataList[i].ProfileUniqeID?dataList[i].ProfileUniqeID:'null',
                    totalamount:dataList[i].amount?parseFloat(dataList[i].amount)*dataList[i].qty:0,
                    issuanceDate:dataList[i].Date?dataList[i].Date:'null',
                    Comments:dataList[i].Description?dataList[i].Description:'null',
                });
            }
        }
        this.setState({DownloadReady:true,giftcardsAMACoupon:giftcardsList,alert:0,alertMessage:'',isLoading: false, });
    }else{
        this.setState({DownloadReady:false,isLoading: false,alert:1,alertMessage:'No records found...',modalShow: false });
    }
    })
        

    }

    DownloadClose = () => {
        if (this._isMounted) {
            this.setState({alert:2,alertMessage:'Report Downloaded...',selectedItem:[], modalShow: false });
        }
    };

    handleClose = () => {
        if (this._isMounted) {
            this.setState({selectedItem:[], modalShow: false });
        }
    };
    render() {
        const options = {
            actionsColumnIndex: -1
        };

        const actions = [
            {
                icon: 'add',
                tooltip: 'Add new',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({modalShow: true, selectedItem: [] });
                    }
                }
            }
        ];

        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}
                {this.state.alert === 2 && (
                    <Alert variant="sucess">{this.state.alertMessage}</Alert>
                )}

                {this.state.isLoading && <Spinner animation="border" />}

                {!this.state.showArchiveList && (
                    <div>
                        <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Report Central
                            </h4>
                        </Row>
                        <div>
                            <hr />
                        </div>
                        <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>
                                    {this.state.search_by =='Status' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {statusArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}
                                    {this.state.search_by !=='Status' &&<Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />}
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>

                        <MaterialTable
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title="GC Master Accounts"
                            columns={[
                                {
                                    title: 'Title',
                                    field: 'title'
                                },
                                { title: 'Action', field: 'balance',
                                render: (row) => (
                                    <div>
                                        <Button
                                        variant="primary"
                                        onClick={(e) =>
                                            this.addReport(row)
                                        }
                                    >
                                        Create Report
                                    </Button>
                                    {/*<Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={(e) =>
                                            this.listArchive(row)
                                        }
                                    >
                                        Archive
                                    </Button>*/}
                                    </div>
                                ) },
                                
                            ]}
                            data={this.state.data}
                            actions={actions}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.data.length <
                                    this.state.perPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {this.state.data.length >=
                                    this.state.perPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    </div>
                )}

                

                


                

            {this.state.showArchiveList && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.hideArchive}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                 {this.state.selectedRow.title} Archive Reports
                            </h4>
                        </Row>

                        <GCArchive MasterGiftCard={this.state.selectedRow} {...this.props} />
                    </div>
                )}


                <Modal  
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                    {this.state.selectedItem.title} New Report
                    </Modal.Header>

                    <Modal.Body>
                    
                    <Form.Row>
                            <Form.Group as={Col}>
                                <MaterialUIPickers
                                id="date-picker-inline1"
                                label="From Date"
                                setDate={(date) => {
                                    this.setState({
                                        report_from_date: this.getFormattedDate(date)
                                    });
                                }}
                            />
                            </Form.Group>
                    </Form.Row>
                    <Form.Row>
                            <Form.Group as={Col}>
                                <MaterialUIPickers
                                id="date-picker-inline2"
                                label="To Date"
                                setDate={(date) => {
                                    this.setState({
                                        report_to_date: this.getFormattedDate(date)
                                    });
                                }}
                            />
                            </Form.Group>
                    </Form.Row>
    
                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>Report Title</Form.Label>
                                <Form.Control
                                    placeholder="Enter title"
                                    type="text"
                                    name="report_title"
                                    value={this.state.report_title}
                                    onChange={this.onChangeValues}
                                    required
                                />
                            </Form.Group>
                    </Form.Row>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        {!this.state.DownloadReady ?<Button variant="primary" onClick={this.createReport}>
                            Generate
                        </Button>:
                        <ExcelFile
                            element={
                                <Button variant="primary" onClick={this.DownloadClose}>
                                        Download Report
                                </Button>
                            }
                            filename={this.state.report_title}
                        >
                            <ExcelSheet
                                data={this.state.giftcardsAMACoupon}
                                name={this.state.report_title}
                            >
                                <ExcelColumn
                                    label="Order Date"
                                    value="issuanceDate"
                                />
                                <ExcelColumn
                                    label="Order ID"
                                    value="giftOrderId"
                                />
                                <ExcelColumn
                                    label="SKU"
                                    value="sku"
                                />
                                <ExcelColumn
                                    label="GC Name"
                                    value="productName"
                                />
                                <ExcelColumn
                                    label="GC Reference Number"
                                    value="refno"
                                />
                                <ExcelColumn
                                    label="Store ID"
                                    value="ProfileUniqeID"
                                />
                                
                                <ExcelColumn
                                    label="Issuance Value"
                                    value="totalamount"
                                />

                                <ExcelColumn
                                    label="Comments"
                                    value="Comments"
                                />
                                
                                
                            </ExcelSheet>
                        </ExcelFile>}
                        
                    </Modal.Footer>
                </Modal>
            </Container>
        );
    }
}

export default AllList;
